<template>
  <transition-group class="p-itemList" tag="div" :css="false">
    <div
      v-for="(item, index) in items"
      :key="item.uuid"
      :class="listItemClassName"
      :index="index"
    >
      <WithReviewButtonBlock :key="index" :item="item">
        <item v-if="!item._destroy" :item="item" :index="index" />
      </WithReviewButtonBlock>
    </div>
  </transition-group>
</template>

<script>
import WithReviewButtonBlock from '../parts/comments/WithReviewButtonBlock'
import Item from '../layout/Item'

export default {
  name: 'PostContentItemLayout',
  components: {
    Item,
    WithReviewButtonBlock
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      listItemClassName: 'p-itemList__item'
    }
  }
}
</script>

<style scoped>
.p-itemList__item {
  transition: all 0.3s;
}
</style>
